import { graphql } from 'react-relay';
import type {
	useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery as useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$data,
	useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQueryVariables as useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$variables,
} from './__types__/useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery.ts';
import type { SpaceSettingsWebItemSectionsInjector } from './SpaceSettingsWebItemSectionsInjector.ts';
import { useSpaceSettingsWebItemSectionsFromQuery } from './useSpaceSettingsWebItemSectionsFromQuery.tsx';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
const useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery = graphql`
	query useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery($spaceKey: String) {
		webItemSections(location: "system.space.tools", key: $spaceKey) {
			id
			label
			cacheKey
			items {
				id
				completeKey
				label
				url
				icon {
					path
				}
			}
		}
		space(key: $spaceKey) {
			alias
			id
			key
			currentUser {
				isAdmin
			}
		}
	}
`;
export type UseSpaceSettingsWebItemSectionsProps = {
	spaceAlias: string;
};

export type UseSpaceSettingsWebItemSectionsReturn = {
	loading: boolean;
	error: Error | undefined;
	webItemSections: ReturnType<SpaceSettingsWebItemSectionsInjector>;
};

export const useSpaceSettingsWebItemSections = ({
	spaceAlias,
}: UseSpaceSettingsWebItemSectionsProps): UseSpaceSettingsWebItemSectionsReturn => {
	const { data, loading, error } = useQueryInterop<
		useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$data,
		useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$variables
	>(useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery, {
		variables: {
			spaceKey: spaceAlias,
		},
	});
	const webItemSections = useSpaceSettingsWebItemSectionsFromQuery(data);
	return {
		loading,
		error,
		webItemSections: !loading && !error ? webItemSections : undefined,
	};
};
